import React, { useState, useEffect } from 'react';
import './styles.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faUser, faFloppyDisk, faXmark } from "@fortawesome/free-solid-svg-icons";
import FloatingActions, { FloatingAction } from '../FloatingActions';
import Card from '../Card';
import ItemListEdit from '../ItemListEdit';
import { ItemRowValue, Option } from '../ItemRow';
import "./styles.css";
import UserSelectAdd, { UserOption } from '../UserSelectAdd';
import ItemDispositionMatrix, { DispositionColumn, IssuedItemRow } from '../ItemDispositionMatrix';
import NewEmploye from '../NewEmploye';
import useRouter from '@/store/useRouter';
import { useShallow } from "zustand/shallow";
import { RouterStoreItemKey } from '@/store/useRouter/types';
import useAppData from '@/store/useAppData';
import axios from "axios";
import { StockMovement } from '@/Utils/constants';
import DialogWindow from '../DialogWindow';
import { urlToDataUrl } from '@/Utils/exportInventoryResultToPdf';
import logoAirlines from "../Login/logoAirlines.png";
import { exportMankoReportToExcel } from '@/Utils/exportMankoReportExcel';

const ReleaseCard: React.FC = () => {

    const selectedStock = useAppData(state => state.selectedStock);
    const loggedUser = useAppData(state => state.user);

    const router = useRouter(
        useShallow(state => ({
            go: state.go,
            history: state.history
        }))
    );

    const laundryItemDispositionMatrix: DispositionColumn[] = [
        { key: "laundry", title: "Do čistírny" }
    ];

    const columnsItemsDispositionMatrix: DispositionColumn[] = [
        { key: "returnNew", title: "Vrátit na sklad\njako nové" },
        { key: "returnUsed", title: "Vrátit na sklad\njako použité" },
        ...(selectedStock.usecleaners ? laundryItemDispositionMatrix : []),
        { key: "dispose", title: "K likvidaci" },
        { key: "notReturnedManko", title: "Nevráceno (pohledávka za zaměstnancem)" },
        { key: "notReturned", title: "Nepožadováno k vrácení" }
    ];

    const [releasedItems, setReleasedItems] = React.useState<ItemRowValue[]>([]);
    const [selectedUsersState, setSelectedUsersState] = React.useState<UserOption[]>([]);
    const selectedUserBuffer = React.useRef<string | null>(null);
    const [selectedUserState, setSelectedUserState] = React.useState<string | null>(null);
    const [issuedItemsState, setIssuedItemsState] = React.useState<IssuedItemRow[]>([]);
    const [displayNewEmployeeCardState, setDisplayNewEmployeeCardState] = React.useState<boolean>(false);
    const [newEmployeeCardNumberState, setNewEmployeeCardNumberState] = React.useState<string | null>(null);
    const [list1Items, setList1Items] = React.useState<Option[]>([]);
    const [list2Items, setList2Items] = React.useState<Option[]>([]);
    const [list3Items, setList3Items] = React.useState<Option[]>([]);
    const [stateItems, setStateItems] = React.useState<Option[]>([]);
    const [showDialog, setShowDialog] = useState<boolean>(false);
    const [dialogText, setDialogText] = useState<string>("");
    const [selectUserReadOnlyState, setSelectUserReadOnlyState] = React.useState<boolean>(false);
    const [archiveUserState, setArchiveUserState] = React.useState<boolean>(false);
    const [savingDataState, setSavingDataState] = useState(false);

    const actions: FloatingAction[] = [
        ...(archiveUserState && selectedUserBuffer.current ? [{
            key: "3",
            label: "Tisk (Výstup)",
            icon: <FontAwesomeIcon icon={faUser} />,
            onClick: () => printArchiveUser()
        }] : []),
        ...(savingDataState ? [
            {
                key: "1",
                label: "Ukládám...",
                icon: <FontAwesomeIcon icon={faFloppyDisk} />,
                onClick: () => { }
            }
        ] : [{
            key: "2",
            label: "Zrušit",
            icon: <FontAwesomeIcon icon={faXmark} />,
            onClick: () => router.go({ key: RouterStoreItemKey.LISTITEMS })
        },
        {
            key: "1",
            label: "Uložit",
            icon: <FontAwesomeIcon icon={faFloppyDisk} />,
            onClick: () => onSave()
        }])
    ]

    useEffect(() => {
        if (!selectedStock) return;

        const loadListsItems = async () => {
            const list1Items = await loadListItems(selectedStock.typeid1, selectedStock.id);
            const list2Items = await loadListItems(selectedStock.typeid2, selectedStock.id);
            const list3Items = await loadListItems(selectedStock.typeid3, selectedStock.id);
            const stateItems = await loadListItems(7, selectedStock.id);

            setList1Items(list1Items);
            setList2Items(list2Items);
            setList3Items(list3Items);
            setStateItems(stateItems);
        };

        void loadListsItems();
    }, [selectedStock]);

    const SCAN_CHAR_MAX_INTERVAL = 40;
    const SCAN_SEQUENCE_TIMEOUT = 120;
    const SCAN_MIN_LENGTH = 1;

    type ScanType = "rfid" | "barcode" | "unknown";

    const scanBufferRef = React.useRef<string>("");
    const scanTimerRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);
    const lastKeyTimeRef = React.useRef<number>(0);
    const lastCharRef = React.useRef<string>("");
    const isScannerSequenceRef = React.useRef<boolean>(false);
    const scannerTargetRef = React.useRef<EventTarget | null>(null);
    const scannerInitialValueRef = React.useRef<string | null>(null);

    const classifyScan = (rawCode: string): ScanType => {
        const code = rawCode.trim();
        console.log("code10:");
        console.log(code);

        if (!code) return "unknown";

        if (/^\d{1,5}$/.test(code)) {
            const n = parseInt(code, 10);
            if (n >= 1 && n <= 50000) {
                return "barcode";
            }
        }

        if (/^[\p{L}0-9+]+$/u.test(code)) {
            return "rfid";
        }

        return "unknown";
    };

    const handleRfidScan = async (rfidCode: string) => {
        try {
            if (selectedUserBuffer.current) {
                return;
            }
            const userId = await loadUserByCardId(rfidCode);

            if (userId && userId?.length > 0) {
                selectedUserBuffer.current = userId[0].id;
                const issuedItems = await loadIssuedItemsByUser(userId[0].id);
                setIssuedItemsState(issuedItems);
            } else {
                setNewEmployeeCardNumberState(rfidCode);
                setDisplayNewEmployeeCardState(true);
            }

        } catch (err) {
            console.error("Failed to handle RFID scan", err);
        }
    };

    const loadStockItemById = async (stockItemId: string) => {

        try {
            const res = await axios({
                method: "post",
                url: "/api/stockItem/get",
                data: {
                    stockItemId,
                    stockId: selectedStock?.id
                },
            });

            if (res.data.stockItem.length > 0) {

                if (res.data.stockItem[0].quantity > 0) {
                    const stockItem = res.data.stockItem[0];
                    stockItem.quantity = 1;

                    setReleasedItems(prev => {
                        const exists = prev.some(item => item.id === stockItem.id);

                        if (exists) {
                            return prev.map(item =>
                                item.id === stockItem.id
                                    ? { ...item, quantity: item.quantity + 1 }
                                    : item
                            );
                        }

                        return [...prev, stockItem];
                    });
                } else {
                    const stockItem = res.data.stockItem[0];
                    setDialogText(`Daná položka není skladem: ${stockItem.id}, ${stockItem.name}`);
                    setShowDialog(true);
                }
            } else {
                setDialogText("Skladová položka nebyla nalezena na daném skladě");
                setShowDialog(true);
            }
        } catch (err) {
            console.error("Failed to load stock item", err);
            throw err;
        }

    };

    const loadStockItemById2 = async (stockItemId: string) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/stockItem/get",
                data: {
                    stockItemId
                },
            });
            return res.data.stockItem[0];
        } catch (err) {
            console.error("Failed to load stock item", err);
            throw err;
        }
    };

    const handleBarcodeScan = async (itemId: number) => {
        try {
            if (!selectedUserBuffer.current) {
                return;
            }

            if (selectUserReadOnlyState || archiveUserState) {
                return;
            }

            await loadStockItemById(String(itemId));

            console.log("Barcode (QR) scanned:", itemId);
        } catch (err) {
            console.error("Failed to handle barcode scan", err);
        }
    };

    const handleScanCompleted = async (rawCode: string) => {
        let code = rawCode.trim();
        code = fixChipCode(code);
        if (!code) return;

        const type = classifyScan(code);
        console.log("Scan done:", { code, type });

        switch (type) {
            case "rfid":
                await handleRfidScan(code);
                break;
            case "barcode":
                await handleBarcodeScan(parseInt(code, 10));
                break;
            case "unknown":
            default:
                console.warn("Unknown scan format:", code);
                break;
        }
    };

    const printArchiveUser = async () => {
        const user = selectedUsersState.filter(user => user.id === selectedUserBuffer.current)[0];
        const logoData = await urlToDataUrl(logoAirlines);

        await exportMankoReportToExcel(user, "Admin", issuedItemsState, {
            title: "Výstup (pohledávka za zaměstnancem)",
            fileName: `Výstup-${user.label}.xlsx`,
            sheetName: "Výstup (pohledávka za zaměstnancem)",
            logoBase64: logoData,
            logoExt: "png",
        });
    };

    useEffect(() => {
        const handleGlobalKeyDown = (e: KeyboardEvent) => {
            const key = e.key;
            console.log("key10:");
            console.log(key);
            if (key.length !== 1) {
                lastCharRef.current = "";
                return;
            }

            const now = performance.now();
            const diff = now - lastKeyTimeRef.current;
            lastKeyTimeRef.current = now;

            const target = e.target as HTMLInputElement | HTMLTextAreaElement | HTMLElement;

            if (!isScannerSequenceRef.current) {
                if (diff > 0 && diff < SCAN_CHAR_MAX_INTERVAL && lastCharRef.current) {
                    isScannerSequenceRef.current = true;
                    scannerTargetRef.current = target;

                    if (target && "value" in target) {
                        const t = target as HTMLInputElement | HTMLTextAreaElement;
                        const currentValue = t.value;
                        const initial =
                            currentValue.endsWith(lastCharRef.current)
                                ? currentValue.slice(0, -lastCharRef.current.length)
                                : currentValue;

                        scannerInitialValueRef.current = initial;
                        t.value = initial;
                    } else {
                        scannerInitialValueRef.current = null;
                    }

                    scanBufferRef.current = lastCharRef.current + key;

                    e.preventDefault();
                    e.stopPropagation();
                } else {
                    lastCharRef.current = key;
                    return;
                }
            } else {
                e.preventDefault();
                e.stopPropagation();
                scanBufferRef.current += key;
            }

            if (scanTimerRef.current) {
                clearTimeout(scanTimerRef.current);
            }

            scanTimerRef.current = setTimeout(() => {
                const fullCode = scanBufferRef.current;
                scanBufferRef.current = "";
                isScannerSequenceRef.current = false;

                const t = scannerTargetRef.current as any;
                if (t && scannerInitialValueRef.current !== null && "value" in t) {
                    t.value = scannerInitialValueRef.current;
                }

                scannerTargetRef.current = null;
                scannerInitialValueRef.current = null;
                lastCharRef.current = "";

                if (fullCode.length >= SCAN_MIN_LENGTH) {
                    void handleScanCompleted(fullCode);
                }
            }, SCAN_SEQUENCE_TIMEOUT);
        };

        window.addEventListener("keydown", handleGlobalKeyDown);

        loadUsers();

        return () => {
            window.removeEventListener("keydown", handleGlobalKeyDown);
        };
    }, []);

    const loadListItems = async (listId: number, stockId: string): Promise<Option[]> => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/listItems/getListItems",
                data: {
                    listId,
                    stockId,
                },
            });

            return res.data.listItems.map((listItem: any): Option => ({
                value: listItem.id,
                label: listItem.name,
            }));
        } catch (err) {
            console.error("Failed to load list items", err);
            throw err;
        }
    };

    const loadIssuedItemsByUser = async (selectedUserId: string): Promise<IssuedItemRow[]> => {
        try {
            const res = await axios({
                method: "post",
                url: "api/issuedItem/getByUser",
                data: {
                    stockId: selectedStock.id,
                    userId: selectedUserId,
                },
            });

            return res.data.issuedItems.map((issuedItem: any): IssuedItemRow => ({
                id: issuedItem.id,
                label: `${issuedItem.name}, ${issuedItem.state}, ${issuedItem.list1}, ${issuedItem.list2}, ${issuedItem.list3}`,
                qty: issuedItem.quantity,
                values: { returnNew: 0, returnUsed: 0, laundry: 0, dispose: 0, notReturned: 0, notReturnedManko: 0 }
            }));
        } catch (err) {
            console.error("Failed to load issued items", err);
            throw err;
        }
    };

    const loadUserByCardId = async (cardId: string): Promise<any> => {
        try {
            const res = await axios({
                method: "post",
                url: "api/user/getByCardid",
                data: {
                    cardId: cardId
                },
            });

            return res.data.user;
        } catch (err) {
            console.error("Failed to load user by card id", err);
            throw err;
        }
    };

    const handleUpdatedItems = (index: number, item: ItemRowValue) => {
        if (index === -1) {
            setReleasedItems((prev) => [...prev, item]);
            return;
        }

        if (!item) {
            setReleasedItems((prev) => prev.filter((_, i) => i !== index));
            return;
        }

        setReleasedItems((prev) =>
            prev.map((row, i) => (i === index ? item : row))
        );
    };

    const setSelectedUserId = async (userId: string) => {
        selectedUserBuffer.current = userId;
        setSelectedUserState(userId);

        if (userId) {
            const issuedItems = await loadIssuedItemsByUser(userId);
            setIssuedItemsState(issuedItems);
        } else {
            setReleasedItems([]);
            setIssuedItemsState([]);
        }
    }

    const onSaveNewEmployee = async (userId: string) => {
        if (!userId) {
            setSelectedUserId(null);
            setNewEmployeeCardNumberState(null);
            setDisplayNewEmployeeCardState(false);
        } else {
            await loadUsers();
            setSelectedUserId(userId);
            setDisplayNewEmployeeCardState(false);

            const issuedItems = await loadIssuedItemsByUser(userId);
            setIssuedItemsState(issuedItems);
        }
    }

    const loadUsers = async () => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/user/getAll",
                })
            );

            if (res.data.users.length > 0) {
                const withoutLaundry = res.data.users.filter(user => user.id != 1);
                setSelectedUsersState(withoutLaundry);
            } else {
                setSelectedUsersState([]);
            }
        } catch (err) {
            throw err;
        }
    }

    const getIssuedItemByStockItemAndUserId = async (stockItemId: string, userId: string): Promise<any> => {
        try {
            const res = await axios({
                method: "post",
                url: "api/issueditem/getByStockItemId",
                data: {
                    stockItemId: stockItemId,
                    objectId: userId
                },
            });

            return res.data.issuedItem;
        } catch (err) {
            console.error("Failed to load getIssuedItemByStockItemAndUserId", err);
            throw err;
        }
    };

    const insertIssuedItem = async (stockItemId: string, objectId: string, quantity: number) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/issueditem/insert",
                data: {
                    stockItemId: stockItemId,
                    objectId: objectId,
                    quantity: quantity
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to insert issued item", err);
            throw err;
        }
    };

    const updateIssuedItemIncrement = async (issuedItemId: string, qauntity: number) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/issueditem/updateIncrement",
                data: {
                    id: issuedItemId,
                    quantity: qauntity
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to update issued item", err);
            throw err;
        }
    };

    const updateStockItemDecrement = async (stockItemId: string, qauntity: number) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/stockitem/updateDecrement",
                data: {
                    id: stockItemId,
                    quantity: qauntity
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to update stock item decrement", err);
            throw err;
        }
    };

    const getStockItemByIssuedItem = async (issuedItemId: string): Promise<ItemRowValue> => {
        try {
            const res = await axios({
                method: "post",
                url: "api/stockitem/getByIssuedItem",
                data: {
                    issueditemid: issuedItemId
                },
            });

            return res.data.stockItem[0];
        } catch (err) {
            console.error("Failed to load getByIssuedItem", err);
            throw err;
        }
    };

    const getStockItemByTypes = async (stockItem: ItemRowValue, stateId: string): Promise<ItemRowValue | null> => {
        try {
            const res = await axios({
                method: "post",
                url: "api/stockitem/getByTypes",
                data: {
                    stateId: stateId,
                    list1Id: stockItem.list1Id,
                    list2Id: stockItem.list2Id,
                    list3Id: stockItem.list3Id,
                    stockId: stockItem.stockId,
                    name: stockItem.name
                },
            });

            if (res.data.stockItem && res.data.stockItem.length > 0) {
                return res.data.stockItem[0];
            } else {
                return null;
            }

        } catch (err) {
            console.error("Failed to load getByTypes", err);
            throw err;
        }
    };

    const updateIssuedItemDecrement = async (issuedItemId: string, qauntity: number) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/issueditem/updateDecrement",
                data: {
                    id: issuedItemId,
                    quantity: qauntity
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to update issued item decrement", err);
            throw err;
        }
    };

    const removeIssuedItem = async (issuedItemId: string) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/issueditem/remove",
                data: {
                    id: issuedItemId
                },
            });

        } catch (err) {
            console.error("Failed to update issued item remove", err);
            throw err;
        }
    };

    const updateStockItemIncrement2 = async (stockItemId: string, qauntity: number) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/stockitem/updateIncrement2",
                data: {
                    id: stockItemId,
                    quantity: qauntity
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to update stock item increment2", err);
            throw err;
        }
    };

    const archiveUser = async (userId: string) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/user/archive",
                data: {
                    id: userId
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to insert stock item", err);
            throw err;
        }
    };

    const insertItem = async (item: ItemRowValue) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/stockitem/insert",
                data: {
                    name: item.name,
                    stateId: item.stateId,
                    list1Id: item.list1Id,
                    list2Id: item.list2Id,
                    list3Id: item.list3Id,
                    quantity: item.quantity,
                    stockId: item.stockId
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to insert stock item", err);
            throw err;
        }
    };

    const stockMovement = async (stockId: string, stockItemId: string, objectId: string, stockMovementId: string, quantity: number, userId: string, returnNew?: boolean, returnUsed?: boolean, dispose?: boolean, notReturned?: boolean, notReturnedManko?: boolean) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/log/stockMove",
                data: {
                    stockId: stockId,
                    stockItemId: stockItemId,
                    objectId: objectId,
                    quantity: quantity,
                    stockMovementId: stockMovementId,
                    returnNew: returnNew,
                    returnUsed: returnUsed,
                    dispose: dispose,
                    notReturned: notReturned,
                    notReturnedManko: notReturnedManko,
                    userId: userId
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to make stock movement item", err);
            throw err;
        }
    };

    const fixChipCode = (str) => {
        if (!str) {
            return str;
        }

        const charMap = {
            "é": "0",
            "+": "1",
            "ě": "2",
            "š": "3",
            "č": "4",
            "ř": "5",
            "ž": "6",
            "ý": "7",
            "á": "8",
            "í": "9"
        };

        return str.split("").map(char => charMap[char] || char).join("");
    }

    const checkReturnUsedAsNewIssuedItems = (issuedItems: IssuedItemRow[]): IssuedItemRow[] => {
        const returnUsedAsNew = issuedItems.filter(
            issuedItem =>
                issuedItem.label.includes(", použité") &&
                issuedItem.values.returnNew > 0
        );

        return returnUsedAsNew;
    };

    const onSave = async () => {

        if (savingDataState) return;

        setSavingDataState(true);

        if (selectedUserBuffer.current) {

            let itemsProcessed = false;
            const checkReturnUsedAsNew = checkReturnUsedAsNewIssuedItems(issuedItemsState);

            if (checkReturnUsedAsNew.length > 0) {
                setDialogText(`Nelze vrátit použitou položku jako novou: (${checkReturnUsedAsNew[0].label})`);
                setShowDialog(true);
                setSavingDataState(false);
                return;
            }

            if (releasedItems && releasedItems.length > 0) {
                let limitExceed = false;
                console.log("releasedItems50");
                console.log(releasedItems);
                for (const releasedItem of releasedItems) {
                    const stockItem = await loadStockItemById2(releasedItem.id);
                    if (releasedItem.quantity > stockItem.quantity) {
                        setDialogText(`Došlo k překročení skladových zásob dané položky Id: ${stockItem.id}`);
                        setShowDialog(true);
                        limitExceed = true;
                        return;
                    }
                }

                if (!limitExceed) {

                    for (const releasedItem of releasedItems) {
                        const issuedItem = await getIssuedItemByStockItemAndUserId(releasedItem.id, selectedUserBuffer.current);
                        console.log("releasedItem10");
                        console.log(releasedItem);
                        if (issuedItem && issuedItem.length > 0) {
                            await updateIssuedItemIncrement(issuedItem[0].id, releasedItem.quantity);
                        } else {
                            await insertIssuedItem(releasedItem.id, selectedUserBuffer.current, releasedItem.quantity);
                        }

                        await updateStockItemDecrement(releasedItem.id, releasedItem.quantity);

                        await stockMovement(selectedStock.id, releasedItem.id, selectedUserBuffer.current, String(StockMovement.Issue), releasedItem.quantity, loggedUser.id);
                    }

                    itemsProcessed = true;
                } else {
                    setSavingDataState(false);
                    return;
                }
            }

            if (issuedItemsState && issuedItemsState.length > 0) {
                for (const issuedItem of issuedItemsState) {

                    let issuedItemQuantity = issuedItem.qty;

                    if (issuedItem.values.returnNew > 0) {
                        const stockItemByIssuedItem = await getStockItemByIssuedItem(issuedItem.id);
                        const stockItemBytState = await getStockItemByTypes(stockItemByIssuedItem, "17");
                        console.log("stockItemBytState");
                        console.log(stockItemBytState);

                        if (issuedItem.values.returnNew === /*issuedItem.qty*/ issuedItemQuantity) {
                            await removeIssuedItem(issuedItem.id);
                            issuedItemQuantity = issuedItemQuantity - issuedItem.values.returnNew;
                        } else if (issuedItem.values.returnNew < /*issuedItem.qty*/ issuedItemQuantity) {
                            await updateIssuedItemDecrement(issuedItem.id, issuedItem.values.returnNew);
                            issuedItemQuantity = issuedItemQuantity - issuedItem.values.returnNew;
                        }

                        if (stockItemBytState) {
                            await updateStockItemIncrement2(stockItemBytState.id, issuedItem.values.returnNew);

                            await stockMovement(selectedStock.id, stockItemBytState.id, selectedUserBuffer.current, String(StockMovement.Return), issuedItem.values.returnNew, loggedUser.id, true, null, null, null, null);
                        } else {
                            const newStockItem = { ...stockItemByIssuedItem, stateId: "17", quantity: issuedItem.values.returnNew };
                            const result = await insertItem(newStockItem);

                            await stockMovement(selectedStock.id, result, selectedUserBuffer.current, String(StockMovement.Return), issuedItem.values.returnNew, loggedUser.id, true, null, null, null, null);
                        }

                        itemsProcessed = true;
                    }

                    if (issuedItem.values.returnUsed > 0) {
                        const stockItemByIssuedItem = await getStockItemByIssuedItem(issuedItem.id);
                        const stockItemBytState = await getStockItemByTypes(stockItemByIssuedItem, "18");

                        console.log("stockItemByIssuedItem");
                        console.log(stockItemByIssuedItem);

                        console.log("stockItemBytState");
                        console.log(stockItemBytState);

                        if (issuedItem.values.returnUsed === /*issuedItem.qty*/ issuedItemQuantity) {
                            await removeIssuedItem(issuedItem.id);
                            issuedItemQuantity = issuedItemQuantity - issuedItem.values.returnUsed;
                        } else if (issuedItem.values.returnUsed < /*issuedItem.qty*/ issuedItemQuantity) {
                            await updateIssuedItemDecrement(issuedItem.id, issuedItem.values.returnUsed);
                            issuedItemQuantity = issuedItemQuantity - issuedItem.values.returnUsed;
                        }

                        if (stockItemBytState) {
                            await updateStockItemIncrement2(stockItemBytState.id, issuedItem.values.returnUsed);

                            await stockMovement(selectedStock.id, stockItemBytState.id, selectedUserBuffer.current, String(StockMovement.Return), issuedItem.values.returnUsed, loggedUser.id, null, true, null, null, null);
                        } else {
                            const newStockItem = { ...stockItemByIssuedItem, stateId: "18", quantity: issuedItem.values.returnUsed };
                            const result = await insertItem(newStockItem);

                            await stockMovement(selectedStock.id, result, selectedUserBuffer.current, String(StockMovement.Return), issuedItem.values.returnUsed, loggedUser.id, null, true, null, null, null);
                        }

                        itemsProcessed = true;
                    }


                    if (issuedItem.values.dispose > 0) {
                        const stockItemByIssuedItem = await getStockItemByIssuedItem(issuedItem.id);

                        if (issuedItem.values.dispose === /*issuedItem.qty*/ issuedItemQuantity) {
                            await removeIssuedItem(issuedItem.id);
                            issuedItemQuantity = issuedItemQuantity - issuedItem.values.dispose;
                        } else if (issuedItem.values.dispose < /*issuedItem.qty*/ issuedItemQuantity) {
                            await updateIssuedItemDecrement(issuedItem.id, issuedItem.values.dispose);
                            issuedItemQuantity = issuedItemQuantity - issuedItem.values.dispose;
                        }

                        await stockMovement(selectedStock.id, stockItemByIssuedItem.id, selectedUserBuffer.current, String(StockMovement.Return), issuedItem.values.dispose, loggedUser.id, null, null, true, null, null);

                        itemsProcessed = true;
                    }

                    if (issuedItem.values.laundry > 0) {
                        const laundryObjectId = "1";
                        const stockItemByIssuedItem = await getStockItemByIssuedItem(issuedItem.id);

                        if (issuedItem.values.laundry === /*issuedItem.qty*/ issuedItemQuantity) {
                            await removeIssuedItem(issuedItem.id);
                            issuedItemQuantity = issuedItemQuantity - issuedItem.values.laundry;
                        } else if (issuedItem.values.laundry < /*issuedItem.qty*/ issuedItemQuantity) {
                            await updateIssuedItemDecrement(issuedItem.id, issuedItem.values.laundry);
                            issuedItemQuantity = issuedItemQuantity - issuedItem.values.laundry;
                        }

                        const issuedItemFroLaundry = await getIssuedItemByStockItemAndUserId(stockItemByIssuedItem.id, laundryObjectId);
                        if (issuedItemFroLaundry && issuedItemFroLaundry.length > 0) {
                            await updateIssuedItemIncrement(issuedItemFroLaundry[0].id, issuedItem.values.laundry);

                            await stockMovement(selectedStock.id, stockItemByIssuedItem.id, selectedUserBuffer.current, String(StockMovement.Laundry), issuedItem.values.laundry, loggedUser.id);
                        } else {
                            await insertIssuedItem(stockItemByIssuedItem.id, laundryObjectId, issuedItem.values.laundry);

                            await stockMovement(selectedStock.id, stockItemByIssuedItem.id, selectedUserBuffer.current, String(StockMovement.Laundry), issuedItem.values.laundry, loggedUser.id);
                        }

                        itemsProcessed = true;
                    }

                    if (issuedItem.values.notReturned > 0) {
                        const stockItemByIssuedItem = await getStockItemByIssuedItem(issuedItem.id);

                        if (issuedItem.values.notReturned === /*issuedItem.qty*/ issuedItemQuantity) {
                            await removeIssuedItem(issuedItem.id);
                            issuedItemQuantity = issuedItemQuantity - issuedItem.values.notReturned;
                        } else if (issuedItem.values.notReturned < /*issuedItem.qty*/ issuedItemQuantity) {
                            await updateIssuedItemDecrement(issuedItem.id, issuedItem.values.notReturned);
                            issuedItemQuantity = issuedItemQuantity - issuedItem.values.notReturned;
                        }

                        await stockMovement(selectedStock.id, stockItemByIssuedItem.id, selectedUserState, String(StockMovement.Return), issuedItem.values.notReturned, loggedUser.id, null, null, null, true, null);

                        itemsProcessed = true;
                    }

                    if (issuedItem.values.notReturnedManko > 0) {
                        const stockItemByIssuedItem = await getStockItemByIssuedItem(issuedItem.id);

                        if (issuedItem.values.notReturnedManko === /*issuedItem.qty*/ issuedItemQuantity) {
                            await removeIssuedItem(issuedItem.id);
                            issuedItemQuantity = issuedItemQuantity - issuedItem.values.notReturnedManko;
                        } else if (issuedItem.values.notReturnedManko < /*issuedItem.qty*/ issuedItemQuantity) {
                            await updateIssuedItemDecrement(issuedItem.id, issuedItem.values.notReturnedManko);
                            issuedItemQuantity = issuedItemQuantity - issuedItem.values.notReturnedManko;
                        }

                        await stockMovement(selectedStock.id, stockItemByIssuedItem.id, selectedUserState, String(StockMovement.Return), issuedItem.values.notReturnedManko, loggedUser.id, null, null, null, null, true);

                        itemsProcessed = true;
                    }
                }
            }

            if (itemsProcessed) {

                if (archiveUserState) {
                    await archiveUser(selectedUserBuffer.current);

                    const issuedItemsNotReturnedManko = issuedItemsState.filter(issuedItem => issuedItem.values.notReturnedManko > 0);
                    if (issuedItemsNotReturnedManko && issuedItemsNotReturnedManko.length > 0) {
                        printArchiveUser();
                    }
                }
                router.go({ key: RouterStoreItemKey.LISTITEMS })
            }
        }

        setSavingDataState(false);
    };

    return (displayNewEmployeeCardState ? (
        <NewEmploye cardNumber={newEmployeeCardNumberState} onSave={onSaveNewEmployee}></NewEmploye>
    ) : (<>
        {showDialog &&
            <DialogWindow
                displayDialog={showDialog}
                setDisplayDialog={setShowDialog}
                title={dialogText}
                cancelText={"OK"}
            />
        }
        <Card
            title="Příjem a výdej zaměstnanci"
        >
            <div className="item-list-stack">

                <div>
                    <UserSelectAdd
                        header="Zaměstnanec"
                        users={selectedUsersState}
                        valueId={selectedUserBuffer.current}
                        onChange={setSelectedUserId}
                        readOnly={!selectUserReadOnlyState}
                        hideHint={true}
                    />

                    <div className="employee-not-present-checkbox">
                        <label>
                            <input
                                type="checkbox"
                                checked={selectUserReadOnlyState}
                                onChange={(e) => {
                                    setSelectUserReadOnlyState(e.target.checked);
                                    setArchiveUserState(e.target.checked);

                                    if (!e.target.checked && loggedUser.userrole != "admin") {
                                        selectedUserBuffer.current = null;
                                        setSelectedUserState(null);
                                        setIssuedItemsState([]);
                                    }

                                    setReleasedItems([]);
                                }
                                }
                            />
                            {' '}Zaměstnanec nepřišel
                        </label>
                    </div>
                    <div className="employee-not-present-checkbox">
                        <label>
                            <input
                                type="checkbox"
                                checked={archiveUserState}
                                onChange={(e) => {
                                    setArchiveUserState(e.target.checked);
                                    setReleasedItems([]);
                                }
                                }
                            />
                            {' '}Výstup
                        </label>
                    </div>
                </div>

                {!selectUserReadOnlyState && !archiveUserState && <ItemListEdit
                    header='Položky k vydání'
                    list1Options={list1Items}
                    list2Options={list2Items}
                    list3Options={list3Items}
                    itemStateOptions={stateItems}
                    displayAddListItem={false}
                    items={releasedItems}
                    onChange={handleUpdatedItems}
                    addRowDisable={true}
                />}

                <ItemDispositionMatrix
                    rows={issuedItemsState}
                    onChange={setIssuedItemsState}
                    columns={columnsItemsDispositionMatrix}
                />
            </div>

            {actions?.length ? (
                <div className="item-list-actions">
                    <FloatingActions actions={actions} />
                </div>
            ) : null}
        </Card></>
    ))
};

export default ReleaseCard;